import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../configs/urlConfig"; // tvoj API base URL
import Utils from "../utils";
import CustomerModal from "../components/CustomerModal";
import Musterije from "../components/Musterije";

axios.defaults.withCredentials = true;

function Users() {
    // uzima datum iz URL-a
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [showModal, setShowModal] = useState(false);
    const fetchData = async () => {
        try {
            setLoading(true);
            setError("");

            // šaljemo datum u backend
            const response = await axios.get(`${API}/get-customers/`, Utils.getUserToken());
            setData(response.data); // pretpostavljam da backend vraća objekat sa poljem "payouts"
        } catch (err) {
            console.error(err);
            setError("Greška prilikom dohvata podataka");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    if (loading)
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                Učitavanje...
            </div>
        );

    if (error)
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <p className="text-danger">{error}</p>
            </div>
        );

    if (!data || !data.payouts)
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <p>Nema podataka</p>
            </div>
        );





    return (
        <div className="container mt-2">
            <div className="mb-4">
                <p className="text-muted d-flex justify-content-between mb-0">
                    <strong>{Utils.formatirajBroj(data.total_amount)} €</strong>

                    <strong>{Utils.formatirajBroj(data.total_payout)} €</strong>
                    <strong>{Utils.formatirajBroj(data.total_paid_all)} €</strong>
                </p>
            </div>

            <Musterije data={data} setData={setData} fetchData={fetchData} />



            <div
                className="d-flex justify-content-between align-items-center w-100"
                style={{
                    zIndex: 20,
                    position: 'fixed',
                    left: 0,
                    bottom: 0,
                    backgroundColor: 'white',
                    padding: '10px',
                }}
            >
                <button
                    type="button"
                    className="btn btn-primary btn-sm desktop-add-btn"
                    onClick={() => setShowModal(true)}
                >
                    Novo
                </button>

                <button
                    type="button"
                    className="btn btn-primary btn-sm desktop-add-btn"
                    onClick={() => navigate('/')}
                >
                    Home
                </button>
            </div>

            {showModal && (
                <CustomerModal
                    onClose={() => setShowModal(false)}
                    onSave={(customer) => fetchData()}
                />
            )}
        </div>
    );
}

export default Users;